import { render, staticRenderFns } from "./tabActivity.vue?vue&type=template&id=3dac35a0&scoped=true"
import script from "./tabActivity.vue?vue&type=script&lang=ts"
export * from "./tabActivity.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dac35a0",
  null
  
)

export default component.exports